<template>
    <div>
        <!-- Modal -->
        <div class="modal fade" id="perfilPacienteModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-dialog22 modal-dialog-total modal-dialog-scrollable" role="document">
                <div class="modal-content modal-content-total">
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLabel">
                            Perfil
                            <span class="ml-2 text-muted" v-if="paciente">
                                {{ paciente.search ? paciente.search : paciente.st_nome }}
                                
                                <span class="badge ml-2" :class="'badge-' + paciente.nps.color" v-if="paciente.nps">
                                    <i class="fa-solid fa-star mr-1"></i>
                                    {{ paciente.nps.score }}
                                </span>
                            </span>
                            <span class="ml-2 text-muted" v-if="temporario">
                                {{ temporario.search ? temporario.search : temporario.st_nome }}
                            </span>
                        </h5>
                        
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div v-if="paciente">
                            <PEP :id="paciente.id_pessoa" ref="pep" :panel="true" @refresh_pac="refresh_pac" :block_foto="true"></PEP>
                        </div>

                        <div v-else-if="temporario">
                            <PEP :tmp="temporario.id_cadastro_temporario" :temporario="temporario" :panel="true" :block_foto="true"></PEP>
                        </div>
                    </div>
                    <div class="modal-footer" v-if="false">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import _ from 'lodash';
import $ from 'jquery';
import PEP from '../modulos/consultorio/PEP.vue';

export default {
    data () { 
        return { 
            paciente: null,
            temporario: null, 
        }
    },

    components: { 
        PEP,
    },

    computed: { 
      telefones: function () { 
        return ( !this.paciente || !this.paciente.cadastro ) ? [] : this.paciente.cadastro.telefone_cadastros.filter((item) => { 
            return item.telefone.st_numero.trim ();
          });
      }
    },

    methods: { 
        refresh_pac(paciente) { 
            if ( !this.paciente || !paciente.search ) { 
                return;
            }

            this.paciente.search = paciente.search;
            this.paciente.nps = paciente.nps;
        },

        sexo (sexo) {
            return sexo == 'M' ? 'Masculino' : ( sexo == 'F' ? 'Feminino' : '' );
        },

        telefone (telefone) { 
            let textoAjustado = "(" + telefone.st_numero.slice(0,2) + ") ";
            if(telefone.ch_tipo_telefone == 'M') {
                const parte1 = telefone.st_numero.slice(2,7);
                const parte2 = telefone.st_numero.slice(7,11);
                textoAjustado = textoAjustado + `${parte1}-${parte2}`        
            } else {
                const parte1 = telefone.st_numero.slice(2,6);
                const parte2 = telefone.st_numero.slice(6,10);
                textoAjustado = textoAjustado + `${parte1}-${parte2}`
            }

            return textoAjustado;
        },
        abrir (paciente) { 
            this.paciente = null;
            this.temporario = null; 

            this.$nextTick(() => { 
                this.paciente = _.cloneDeep (paciente);
                $('#perfilPacienteModal').modal('show');
            });
        },

        abrir_temporario (temporario) { 
            this.paciente = null;
            this.temporario = null; 

            this.$nextTick(() => { 
                this.temporario = _.cloneDeep (temporario);
                $('#perfilPacienteModal').modal('show');
            });
        }

    }
}
</script>

<style scoped>
.modal-dialog-total {
  top: 0;
  width: 100% !important;
  height: 100% !important;
  padding: 0 !important;
  max-width: 100% !important;
  max-height: 100% !important;
  margin-top: 0px;
  margin-bottom: 0px;
  margin: 0px !important;
}

.modal-content-total {
  height: 100% !important;
  max-height: 100% !important;
}

.modal-dialog2 {
  width: 98% !important;
  min-height: 98% !important;
  padding: 0 !important;
  max-width: 100%;
}

.modal-dialog {
  width: 100%;
  height: 100%;
  padding: 0;
}

.modal-content {
  min-height: 96%;
  height:auto;
}
</style>